import { colors, medias } from 'assets/styled/tokens';
import styled from 'styled-components';

export const ImageUploadContainer = styled.div`
  position: relative;
  max-width: 468px;
  width: 154px;
  height: 124px;
  border: ${props => (props.borderDashed ? '2px dashed #cccccc' : '2px solid #cccccc')};
  border-radius: 3px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: ${medias.desktopSm}) {
    width: 260px;
  }
`;
export const Wrapper = styled.div`
  //margin: 0 10px;
  display: flex;
  flex-direction: column;
  width: ${props => props.width};
  h5 {
    font-family: Roboto;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: #888888;
    margin-bottom: 25px;
  }
  div {
    display: flex;
    flex-direction: column;
    @media (min-width: ${medias.desktopSm}) {
    }
  }
`;
export const InputLabel = styled.div`
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
  color: #1e1e1e;
`;
export const Input = styled.input`
  display: none;
`;

export const Label = styled.label`
  font-family: Roboto;
  position: absolute;
  color: #000000;
  font-weight: 500;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  font-weight: bold;
  display: block;
  width: 100%;
  font-size: 13px !important;
  padding: 0 30px;
  div:first-of-type {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
`;

export const SubLabel = styled.b`
  font-weight: normal;
  text-decoration: underline;
  display: block;
  cursor: pointer;
  font-size: 12px !important;
  margin: 0 0 0 5px !important;
  font-weight: 500;
  color: ${colors.primary};
`;
export const SubLabelWrapper = styled.span`
  display: flex;
  justify-content: center;
`;
export const PreviewImage = styled.img`
  width: 93px;
  height: 93px;
  border-radius: 4px;
  border: 2px solid #bbbbbb;
  @media (min-width: ${medias.desktopSm}) {
    width: 164px;
    height: 164px;
  }
`;
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  max-width: 468px;
`;

export const ButtonTrash = styled.button`
  background-color: #fff;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  margin-left: 5px;
  border-radius: 3px;
`;
export const Button = styled.button`
  position: absolute;
  top: -12px;
  right: -4px;
  background: ${colors.black};
  border: none;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: rgba(255, 0, 0, 0.8);
  }

  svg {
    width: 16px;
    height: 16px;
    fill: #000;

    &:hover {
      fill: #fff;
    }
  }
  @media (min-width: ${medias.desktopSm}) {
    right: -5px;
  }
`;

export const InputColumn = styled.div`
  display: flex;
  flex-direction: row !important;
  justify-content: space-between;
  height: auto;
  //gap: 20px;
  margin-bottom: 25px;
`;
export const PreviewImagesContainer = styled.div`
  display: flex;
  gap: 11px;
  margin-top: 20px;
  //flex-wrap: wrap;
  //margin-top: 40px;
  width: 93px;
  height: 93px;
  flex-direction: row !important;
  div {
    position: relative;
  }
  @media (min-width: ${medias.desktopSm}) {
    flex-direction: row !important;
    width: 260px;
    height: auto;
    gap: 16px;
    margin-top: 0;
  }
`;
